import { render, staticRenderFns } from "./FluxBrowser.vue?vue&type=template&id=356ba8ba&scoped=true&"
import script from "./FluxBrowser.vue?vue&type=script&lang=js&"
export * from "./FluxBrowser.vue?vue&type=script&lang=js&"
import style0 from "./FluxBrowser.vue?vue&type=style&index=0&id=356ba8ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356ba8ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VProgressLinear,VRow,VSpacer})
